const FromArrEditor = [{
	key: 'Name',
	title: "名称：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 220,
	height: 32,
	disabled: false,
	marginLeft: 10,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 400
}];
export default FromArrEditor;